import useAssignmentForm from '@/components/AssignmentForm/useAssignmentForm';
import Breadcrumbs from '@/components/Breadcrumbs';
import useTopbar from '@hooks/useTopbar';

/**
 * The same assignment form the app page uses, with no submit passed: user
 * assignments have no endpoint yet, so the fields and their validation work but
 * Submit stays off. Add a `submit` here once there is one to call.
 */
const useAddUserPage = () => {
	useTopbar(<Breadcrumbs />);

	return useAssignmentForm();
};

export default useAddUserPage;
